/**
 * 获取各平台主账号用户权限: 菜单权限、按钮权限
 * @returns {Promise}
 */
export function getPermissionList() {
  return ZP.Ajax({
    url: '/api/user/manage/index/permission',
  });
}
